<template>
    <div class="content-view">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <div class="header">
                    <span>全部数据</span>
                    <el-input class='searchDiv' prefix-icon="el-icon-search" v-model='searchValue' placeholder="" size="mini" @input='researchKeyWord' />
                </div>
            </div>
            <div class="bookInfo" v-for="(item, index) of records" :key="index">
                <div class="title" v-if="currentBookType.key === 'base'" @click="goToPage(item)">{{item.title}}</div>
                <div class="content" v-if="currentBookType.key === 'base'">{{item.abstract}}</div>
                <div class="contributor" v-if="currentBookType.key === 'base'">{{item.contributor}}</div>

                <div class="title" v-if="currentBookType.key === 'schema'" @click="goToPage(item)">{{item.title}}</div>
                <div class="content" v-if="currentBookType.key === 'schema'">{{item.abstract}}</div>
                <div class="contributor" v-if="currentBookType.key === 'schema'">{{item.sourceTitle}}</div>

                <div class="title" v-if="currentBookType.key === 'pic'" @click="goToPage(item)">{{item.title}}</div>
                <div class="content" v-if="currentBookType.key === 'pic'">{{item.abstract}}</div>
                <div class="contributor" v-if="currentBookType.key === 'pic'">{{item.sourceTitle}}</div>

                <div class="title" v-if="currentBookType.key === 'person'" @click="goToPage(item)">{{item.personalName}}</div>
                <div class="content" v-if="currentBookType.key === 'person'">{{item.biography}}</div>
                <div class="contributor" v-if="currentBookType.key === 'person'">{{item.sourceTitle}}</div>

                <div class="title" v-if="currentBookType.key === 'org'" @click="goToPage(item)">{{item.chiOrganizationName}} - {{item.type}}</div>
                <div class="content" v-if="currentBookType.key === 'org'">{{item.description}}</div>
                <div class="contributor" v-if="currentBookType.key === 'org'">{{item.sourceTitle}}</div>

                <div class="title" v-if="currentBookType.key === 'event'" @click="goToPage(item)">{{item.Name}} - {{item.type}}</div>
                <div class="content" v-if="currentBookType.key === 'event'">{{item.description}}</div>
                <div class="contributor" v-if="currentBookType.key === 'event'">{{item.sourceTitle}}</div>

                <div class="title" v-if="currentBookType.key === 'geo'" @click="goToPage(item)">{{item.geographicalName}}</div>
                <div class="content" v-if="currentBookType.key === 'geo'">{{item.jurisdiction}}</div>
                <div class="contributor" v-if="currentBookType.key === 'geo'">{{item.sourceTitle}}</div>
            </div>

            <el-pagination show-quick-jumper :default-current="pageIndex" :pageSize.sync='pageSize' :total="total" :show-total="total => `共${total}条记录`" @current-change="changeTablePage" />
        </el-card>
    </div>
</template>

<script>
import bookApi from '@/api/ancient'

export default {
    data () {
        return {
            records: [],
            currentBookType: {},
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            searchValue: ''
        }
    },
    mounted () {
    },
    methods: {
        getData () {
            this.records = [];

            if (this.currentBookType.path === '') {
                return;
            }

            let that = this;

            bookApi.getAncient({
                path: this.currentBookType.path,
                pageindex: this.pageindex,
                pageSize: this.pageSize,
                keyWord: this.searchValue,
                libraryCode: this.global.getLibraryInfos().code

            }).then(response => {
                console.log(response);
                if (response.code === 200) {
                    that.total = response.data.count;
                    that.records = response.data.rows;
                }
            })
        },
        researchKeyWord () {
            // console.log(e);
            this.pageIndex = 1;
            this.getData();
        },
        changeTablePage (e) {
            this.pageindex = e;
            this.getData();
        },
        changeBookSelect (item) {
            this.searchValue = '';
            this.currentBookType = item;
            this.getData();
        },
        goToPage (item) {
            let routeData = this.$router.resolve({
                path: '/bookView',
                query: {
                    bookId: item.sourceID,
                    bookType: 'book'
                }
            });

            // 必要操作，否则不会打开新页面
            window.open(routeData.href, '_blank');
        }
    }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.content-view {
    width: 900 * @uw;
    // height: 50 *@uw;
    // background: bisque;

    .header {
        width: 100%;
        height: 25 * @uh;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .search-box {
            width: 250 * @uw;
            display: flex;
            align-items: center;
        }
    }

    .searchDiv{
        width: 200 * @uw;
        // margin: 0px 0 20px 0px;
    }

    .bookInfo {
        margin-bottom: 30 * @uh;
        padding-bottom: 10 * @uh;
        border-bottom: dashed 1px rgba(0,0,0,.1);
        .title {
            color: #6d6d6d;
            font-size: 18 * @uw;
            font-weight: bold;
            margin-bottom: 10 * @uh;
            cursor: pointer;
        }

        .content {
            font-size: 14 * @uw;
            margin-bottom: 10 * @uh;
        }

        .contributor {
            font-size: 13 * @uw;
            color: #8e8e8e;
        }
    }
}

:deep(.el-card__header) {
    color: #8d5e1a;
    font-weight: bold;
}
</style>
